import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/toPromise';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/shared/services/error-handler.service';

@Injectable()
export class SupplierService {

  public pageUrl = new Subject<string>();
  public pageUrl$ = this.pageUrl.asObservable();
  public supplierUrl = environment.runtime.userManagementApiUrl;
  public userUrl = environment.runtime.userManagementApiUrl;
  public all: {}[] = [];
  public newSupplierUser: any = {};
  public updatedSupplierUser: any = { organization: {}};
  public nameIsInvalid: boolean = false;
  public invalidNameErrorMessage: string = '';
  public requestsCount: number = 0;
  public currentSupplierID: string = '';
  private httpClient: HttpClient;

  constructor(private authHttp: HttpClient, private errorHandlerService: ErrorHandlerService, handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
   }

   getSuppliers(): Promise<{}[]> {
    return this.authHttp.get(`${this.supplierUrl}/supplier/supplier`)
      .toPromise()
      .then(response => {
        this.filterSuppliers(response);
        return response;
      })
      .catch(e => this.errorHandlerService.handleError(e, e.message));
  }

  private filterSuppliers(suppliers) {
    let sortedUsers: {}[];

    sortedUsers = suppliers.sort((a: any, b: any) => {
      let x = a['name'].toLowerCase();
      let y = b['name'].toLowerCase();
      if (x < y) {
        return -1;
      } else if (x > y) {
        return 1;
      }
      return 0;
    });
    this.all = sortedUsers;
  }

  getSupplier(id: string): {} {
    return this.all.filter(supplier => supplier['id'] === id)[0];
  }

  getSupplierUsers(id: string) {
    return this.authHttp.get(`${this.supplierUrl}/supplier/users/`+id)
    .toPromise()
    .then(response => response)
    .catch(e => this.errorHandlerService.handleError(e, e.message));
  }

  getSupplierDetail(id: string) {
    return this.authHttp.get(`${this.supplierUrl}/supplier/supplier/`+id)
               .toPromise()
               .then(response => response)
               .catch(e => this.errorHandlerService.handleError(e, "error retrieving supplier info"));
  }

  deleteSupplier(id: string) {
    return this.authHttp.post(`${this.supplierUrl}/supplier/delete/`+id, {status: 'inactive'})
               .toPromise()
               .then(response => response)
               .catch(e => this.errorHandlerService.handleError(e, "error deleting Supplier"));
  }

//   return this.authHttp.post(`${this.purchaseOrderApiUrl}/xref`, { custSupID: customerSupplierID, custID: customerID, suppID: supplierID, suppName: supplierName })

  updateSupplier(supplierID, supplierData) {
    return this.authHttp.post(`${this.supplierUrl}/supplier/update/`+supplierID, supplierData)
               .toPromise()
               .then(response => response)
               .catch(e => this.errorHandlerService.handleError(e, "error updating Supplier"));

  }

  public changeSupplierId(id){
    this.currentSupplierID = id;
  }

  public changeSupplier(supplier) {
    this.updatedSupplierUser.organization['organizationName'] = supplier.name;
    this.updatedSupplierUser.organization['organizationCode'] = supplier.id;
  }

  public invalidName(event, name){
    let invalidPattern = event.srcElement.validity.patternMismatch;
    if (!invalidPattern){
      this.nameIsInvalid = false;
    } else if (invalidPattern && name.includes('  ')){
      this.nameIsInvalid = true;
      this.invalidNameErrorMessage = "Please enter both a first and last name seperated by single space characters";
    } else if (invalidPattern && !name.includes('  ')){
      this.nameIsInvalid = true;
      this.invalidNameErrorMessage = "Please enter both a first and last name";
    }
  }

  getSupplierUser(id: string): Promise<{}[]> {
    return this.authHttp.get(`${this.userUrl}/user/get/`+id)
               .toPromise()
               .then(response => response)
               .catch(e => this.errorHandlerService.handleError(e, e.message));
  }

  createSupplierUser(): Promise<any> {
  return this.authHttp.post(`${this.userUrl}/user/create`, this.newSupplierUser)
      .toPromise();
  }

  updateSupplierUser(id: string): Promise<{}[]>{
    return this.authHttp.post(`${this.userUrl}/user/update/other/`+id, this.updatedSupplierUser)
               .toPromise()
               .then(response => response)
               .catch(e => this.errorHandlerService.handleError(e, e.message));
  }

  resetSupplierUser(): void {
    this.newSupplierUser = {};
  };

  getSupplierCustomers(id): Promise<{}[]> {
    return this.authHttp.get(`${this.supplierUrl}/supplier/customers/`+id)
               .toPromise()
               .then(response => response)
               .catch(e => this.errorHandlerService.handleError(e, e.message));
  };

  createSupplier(supplier): Promise<{}[]> { // modify the payload sent to backend
    let data = {
      name: supplier.name,
      status: "active",
      location: {
        domainName: supplier.DomainName,
        nameLocation: supplier.LocationName,
        LocationType: supplier.LocationType,
        address: supplier.Address1,
        address2: supplier.Address2 || "",
        city: supplier.City,
        state: supplier.State,
        postalCode: supplier.PostalCode,
        countryCode: supplier.CountryCode,
        Latitude: "",
        Longitude: ""
      },
      contacts : [{
        phone: supplier.corporate_phone,
        email: supplier.corporate_email,
        name: supplier.contactName
      }]
    };
    return this.authHttp.post(`${this.supplierUrl}/supplier/supplier`, data)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.message));
  };

  uploadFile(fd): Promise<{}[]>{
    let headers = new HttpHeaders();
    headers = headers
    .set('Authorization', `Bearer ${this.getBearerToken()}`);
    return this.httpClient.post(`${this.supplierUrl}/supplier/upload`, fd, { headers: headers})
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.message));
  };
  private getBearerToken() {
    return localStorage.getItem('access_token');
  }

  getMatchingSuppliers(name): Promise<{}[]> {
    return this.authHttp.get(`${this.supplierUrl}/supplier/regex?name=${name}`)
      .toPromise()
      .then(response => response)
      .catch(e => this.errorHandlerService.handleError(e, e.message));
  };

  linkCustomer(payload) {
    return this.authHttp.post(`${this.supplierUrl}/supplier/addSupplierXREF`, payload)
    .toPromise()
  }

  unlinkCustomer(payload) {
    return this.authHttp.post(`${this.supplierUrl}/supplier/removeSupplierXREF`, payload)
      .toPromise()
  }

  unlinkLocation(locationId, supplierId) {
    return this.authHttp.delete(`${this.supplierUrl}/supplier/location/${supplierId}/${locationId}`)
      .toPromise()
      .then(response => response)
      .catch(e => {
        this.errorHandlerService.handleError(e, e.message);
      });
  }

  updateReleaseStatus(paylaod) {
    return this.authHttp.post(`${this.supplierUrl}/supplier/allowRelease`, paylaod)
      .toPromise()
  }
  /**
   * Requests api for Suppliers with given filter parameters
   * @param filterBody
   * @return promise of filtered suppliers
   */
  public getFilteredSuppliers(filterBody: any, endpoint: string = '/supplier/filter'): Promise<any> {
    return this.authHttp.post(`${this.supplierUrl}${endpoint}`, filterBody).toPromise();
  }
}
